// extracted by mini-css-extract-plugin
module.exports = {"noTicketsInfo":"Checkin_noTicketsInfo__L0p34"};